import { mergeProps, splitProps, useContext } from "solid-js";
import classNames from "./classnames";
import { useBootstrapPrefix } from "./ThemeProvider";
import FormContext from "./FormContext";
const defaultProps = {
    isValid: false,
    isInvalid: false,
};
const FormSelect = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), [
        "bsPrefix",
        "size",
        "htmlSize",
        "class",
        "isValid",
        "isInvalid",
        "id",
    ]);
    const formContext = useContext(FormContext);
    const bsPrefix = useBootstrapPrefix(local.bsPrefix, "form-select");
    return (<select {...props} size={local.htmlSize} class={classNames(local.class, bsPrefix, local.size && `${bsPrefix}-${local.size}`, local.isValid && `is-valid`, local.isInvalid && `is-invalid`)} id={local.id || formContext.controlId}/>);
};
export default FormSelect;
